import * as React from 'react'
import {inject, observer} from 'mobx-react'
import {StoreProps} from 'src/stores'
import styled from 'styled-components'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import {FuneralTypeEnum, PlanningReasonEnum} from 'src/resources'

const trustedShops = require('src/assets/redesign/trusted_shops_logo.png')
const google = require('src/assets/configurator/google_reviews.png')
const funeralHomeCertificate = require('src/assets/wizard/funeralHomeCertificate.png')

@inject('wizardStore')
@observer
export class WizardProcessOverview extends React.Component<StoreProps> {
  constructor(props) {
    super(props)
    const { wizardStore } = props
    const query = new URLSearchParams(location.search)
    let preSelect = PlanningReasonEnum[query.get('planningReason')]
    if (preSelect) {
      wizardStore.basics.planningReason = preSelect
    } else {
      preSelect = FuneralTypeEnum[query.get('funeralType')]
      if (preSelect) wizardStore.basics.funeralType = preSelect
    }
  }

  componentDidMount() {
    const { wizardStore } = this.props
    wizardStore.readProcessInfo = true
    window.dataLayer.push({ event: 'optimize.wizard_start' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_start' })
  }

  render() {
    const { wizardStore } = this.props
    return (
      <WizardContainer>
        <Box>
          <Question style={{ paddingBottom: '0px' }}>
            Wie funktioniert die Bestattungsplanung?
          </Question>
          <Content>
            <Number>1</Number>
            <p>Wichtigste Fragen zur Bestattung beantworten</p>
            <Number>2</Number>
            <p>Details der Bestattung (Sarg, Urne, Friedhof, … ) auswählen</p>
            <Number>3</Number>
            <p>Kostenfreies Angebot als PDF herunterladen</p>
          </Content>
          <Footer>
            <img src={google} alt='google' />
            <img src={trustedShops} alt='trusted_shops' />
            <img src={funeralHomeCertificate} alt='bestattung_staatlich_geprueft' />
          </Footer>
        </Box>
        <Navigation
          next={wizardStore.nextWizardStep}
          text='Weiter'
          disabled={false}
        />
      </WizardContainer>
    )
  }
}

const Number = styled.span`
  display: inline-block;
  font-size: 18px;
  line-height: 30px;
  color: #57767a;
  font-family: 'Montserrat';
  font-weight: 700;
  text-align: center;
  background-color: #a6c9cd;
  width: 30px;
  height: 30px;
  border-radius: 23px;
  margin-right: 13px;
`

const Content = styled.div`
  margin: 30px auto;
  padding: 0 50px;
  text-align: center;
  p {
    font-size: 18px;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  padding: 10px;
  background: #f0f0f5;
  img {
    flex: flex-shrink;
    width: 80px;
  }
  p {
    margin: 0;
    line-height: 1.3;
  }
`
export default WizardProcessOverview



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/WizardProcessOverview.tsx